import { Dispatch, useMemo } from 'react';

import {
  Action,
  addMessageAction,
  addMessageFailAction,
  addMessageSuccessAction,
  addReactionAction,
  archiveConversation,
  insertMessagesAction,
  lockScrollAction,
  muteConversationAction,
  removeMessageAction,
  removeReactionAction,
  selectQuotedMessageAction,
  setConversationAction,
  setEditMessageAction,
  setMarkedMessageAction,
  setReactionAction,
  setUnreadMessagesCountAction,
  setUnreadMessageMarkerAction,
  unarchiveConversationAction,
  unlockScrollAction,
  unmuteConversationAction,
  unselectQuotedMessageAction,
  updateConversationAction,
  updateMessageAction,
} from '../conversationProvider.actions';
import {
  ConversationActions,
  AddMessageActionPayload,
  AddMessageActionFailPayload,
  AddMessageActionSuccessPayload,
  AddReactionPayload,
  ArchiveConversationPayload,
  InsertMessageActionPayload,
  MuteConversationActionPayload,
  RemoveMessageActionPayload,
  RemoveReactionPayload,
  SelectQuotedMessageActionPayload,
  SetConversationActionPayload,
  SetEditMessageActionPayload,
  SetMarkedMessageActionPayload,
  SetReactionPayload,
  SetUnreadMessagesCountPayload,
  SetUnreadMessageMarkerActionPayload,
  UnarchiveConversationPayload,
  UnselectQuotedMessageActionPayload,
  UnmuteConversationActionPayload,
  UpdateConversationActionPayload,
  UpdateMessageActionPayload,
} from '../conversationProvider.types';

export const useCreateConversationActions = (dispatch: Dispatch<Action>): ConversationActions => {
  return useMemo(
    () => ({
      addMessage: (payload: AddMessageActionPayload) => dispatch(addMessageAction(payload)),
      addMessageFail: (payload: AddMessageActionFailPayload) =>
        dispatch(addMessageFailAction(payload)),
      addMessageSuccess: (payload: AddMessageActionSuccessPayload) =>
        dispatch(addMessageSuccessAction(payload)),
      addReaction: (payload: AddReactionPayload) => dispatch(addReactionAction(payload)),
      archiveConversation: (payload: ArchiveConversationPayload) =>
        dispatch(archiveConversation(payload)),
      insertMessages: (payload: InsertMessageActionPayload) =>
        dispatch(insertMessagesAction(payload)),
      lockScroll: () => dispatch(lockScrollAction()),
      muteConversation: (payload: MuteConversationActionPayload) =>
        dispatch(muteConversationAction(payload)),
      removeMessage: (payload: RemoveMessageActionPayload) =>
        dispatch(removeMessageAction(payload)),
      removeReaction: (payload: RemoveReactionPayload) => dispatch(removeReactionAction(payload)),
      selectQuotedMessage: (payload: SelectQuotedMessageActionPayload) =>
        dispatch(selectQuotedMessageAction(payload)),
      setConversation: (payload: SetConversationActionPayload) =>
        dispatch(setConversationAction(payload)),
      setEditMessage: (payload: SetEditMessageActionPayload) =>
        dispatch(setEditMessageAction(payload)),
      setMarkedMessage: (payload: SetMarkedMessageActionPayload) =>
        dispatch(setMarkedMessageAction(payload)),
      setReaction: (payload: SetReactionPayload) => dispatch(setReactionAction(payload)),
      setUnreadMessagesCount: (payload: SetUnreadMessagesCountPayload) =>
        dispatch(setUnreadMessagesCountAction(payload)),
      setUnreadMessageMarker: (payload: SetUnreadMessageMarkerActionPayload) =>
        dispatch(setUnreadMessageMarkerAction(payload)),
      unarchiveConversation: (payload: UnarchiveConversationPayload) =>
        dispatch(unarchiveConversationAction(payload)),
      unlockScroll: () => dispatch(unlockScrollAction()),
      unmuteConversation: (payload: UnmuteConversationActionPayload) =>
        dispatch(unmuteConversationAction(payload)),
      unselectQuotedMessage: (payload: UnselectQuotedMessageActionPayload) =>
        dispatch(unselectQuotedMessageAction(payload)),
      updateConversation: (payload: UpdateConversationActionPayload) =>
        dispatch(updateConversationAction(payload)),
      updateMessage: (payload: UpdateMessageActionPayload) =>
        dispatch(updateMessageAction(payload)),
    }),
    [dispatch]
  );
};
